import { motion } from 'framer-motion';
import { FaBitcoin, FaHandshake, FaRocket } from 'react-icons/fa';

const Features = () => {
  return (
    <div className="bg-dark py-20">
      <div className="container mx-auto px-4">
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 0.8 }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl font-bold text-white mb-4">
            Empowering Features
          </h2>
          <p className="text-gray-300 max-w-2xl mx-auto">
            Discover how Mo<span className="text-primary">bnb</span> is revolutionizing the path to economic independence
            through cutting-edge blockchain technology
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <motion.div
              key={feature.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.2 }}
              className="bg-secondary p-6 rounded-lg"
            >
              <feature.icon className="text-primary text-3xl mb-4" />
              <h3 className="text-xl font-semibold text-white mb-2">
                {feature.title}
              </h3>
              <p className="text-gray-300">{feature.description}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
};

const features = [
  {
    icon: FaBitcoin,
    title: "Smart Contract Technology",
    description: "Leverage the power of blockchain for secure and transparent transactions."
  },
  {
    icon: FaHandshake,
    title: "Community Collaboration",
    description: "Join forces with like-minded individuals to achieve shared success."
  },
  {
    icon: FaRocket,
    title: "Progressive Growth",
    description: "Accelerate your journey towards financial independence."
  }
];

export default Features;